export const PreOnboardingConfig = [
    {
        step: 0,
        key: 'entity_type',
        title: 'What describes your business best?',
        type: 'radio',
        options: [
            { key: 'Private Ltd/Public Ltd/One Person Company', value: '11' },
            { key: 'Partnership Firm', value: '9' },
            { key: 'Sole Proprietor', value: '10' },
            { key: 'Limited liability partnership (LLP)', value: '7' },
            { key: 'Hindu Undivided Family (HUF)', value: '5' },
        ],
        ctaText: 'Next',
        onboarding_step: 'pre_kyc_entity_type',
    },
    {
        step: 1,
        key: 'business_category',
        title: 'What is your business category?',
        type: 'radio',
        options: [
            { key: 'Beauty accessories', value: 'Beauty accessories' },
            { key: 'Ecommerce', value: 'Ecommerce' },
            { key: 'Fashion', value: 'Fashion' },
            { key: 'FMCG', value: 'FMCG' },
            { key: 'Food and Beverages (Fastfood)', value: 'Food and Beverages (Fastfood)' },
            { key: 'Grocery', value: 'Grocery' },
            { key: 'Healthcare', value: 'Healthcare' },
            { key: 'Jewellery', value: 'Jewellery' },
            { key: 'SaaS', value: 'SaaS' },
            { key: 'Services (Business/Home)', value: 'Services (Business/Home)' },
            { key: 'Sports and Games', value: 'Sports and Games' },
            { key: 'Wholesale Trade and B2B', value: 'Wholesale Trade and B2B' },
            { key: 'Furniture', value: 'Furniture' },
            { key: 'Home Decor', value: 'Home Decor' },
            { key: 'Electronics', value: 'Electronics' },
            { key: 'Footwear', value: 'Footwear' },
            { key: 'Marketplace', value: 'Marketplace' },
            { key: 'Departmental store and ecom', value: 'Departmental store and ecom' },
            { key: 'Mobile Accessories', value: 'Mobile Accessories' },
        ],
        ctaText: 'Next',
        onboarding_step: 'pre_kyc_business_category',
    },
    {
        step: 2,
        title: 'Do you have a GST Certificate?',
        key: 'gst_certificate',
        type: 'radio',
        options: [
            { key: 'Yes, I have a GST Certificate', value: 'Yes' },
            { key: 'No, I don’t have', value: 'No' },
        ],
        ctaText: 'Next',
        onboarding_step: 'pre_kyc_business_category',
    },
]
